import React from "react";
import { AppBar, Toolbar, Box, Button } from "@mui/material";

const Navbar = ({ onGetStartedClick }) => {
  return (
    <AppBar
      position="static"
      elevation={1}
      sx={{
        backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        padding:"10px",
        
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Logo */}
        <Box
          component="img"
          src="https://design247bucket.s3.ap-south-1.amazonaws.com/Design247new+logo.png"
          alt="Design247 Logo"
          sx={{ height: 60, ml: 5 }}
        />

        {/* Get Started Button */}
      <Button
  variant="contained"
  onClick={onGetStartedClick}
  sx={{
    backgroundColor: "#333",
      fontWeight: 600,
    mr:"20px",
    fontSize: "16px", // increased font size
    height: "50px",
    borderRadius: "5px", // optional rounded corners
    textTransform: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#1c1c1c",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)", // subtle hover shadow
    },
  }}
>
  Get Started
</Button>

      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
